import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "panel" }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ApiParams } from '@/core/http/ApiResource';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { LawFirm, useLawFirm } from '@/modules/law_firm/LawFirm';


export default /*@__PURE__*/_defineComponent({
  __name: 'LawFirmIndex',
  setup(__props) {

const resource = useLawFirm();
const { $gettext } = useGettext();
const defaultParams: ApiParams = {};
const lawFirmToDelete = ref<LawFirm>();

const columns = [
	new Column<LawFirm>($gettext('Namn'), 'name', 'name', '+'),
	new Column<LawFirm>($gettext('Organisationsnummer'), 'identity_number', 'identity_number'),
	new ActionColumn<LawFirm>()
		.withLink(
			'users',
			't-neutral',
			(lf: LawFirm) => ({ name: 'law_firm.user.index', params: { law_firm_id: lf.id } }),
		)
		.withEditLink((lf) => ({ name: 'law_firm.edit', params: { id: lf.id } }))
		.withDeleteLink((lf: LawFirm) => {
			lawFirmToDelete.value = lf;
		}),
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Externa partners')
  }, {
    "header-actions": _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {name: 'law_firm.create'},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Ny extern partner ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ResourceTable, {
          resource: _unref(resource),
          columns: columns,
          "default-params": defaultParams,
          "delete-title": _unref($gettext)('Ta bort extern partner'),
          "delete-name-key": "name",
          "to-delete": lawFirmToDelete.value,
          "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((lawFirmToDelete).value = $event))
        }, null, 8, ["resource", "delete-title", "to-delete"])
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})